import axiosInstance from "../../lib/axiosInstance";
import { toast } from "react-toastify";
import { AppDispatch } from "../store";
import { schoolActions } from "../slices/school";
import { getErrorMessage } from "../../utils/errorUtils";
import { SchoolResponseDto } from "../../shared/dtos/school/SchoolResponseDto";
import { SchoolUpdateRequestDto } from "../../shared/dtos/school/SchoolUpdateRequestDto";
import { ApiResponseDto } from "../../shared/dtos/common/ApiResponseDto";
import { ApiResponseStatus } from "../../shared/enums/ApiResponseStatus";

export const getSchool = () => async (dispatch: AppDispatch) => {
  dispatch(schoolActions.setLoadingSchool());
  try {
    const { data } = await axiosInstance.get<ApiResponseDto<SchoolResponseDto>>(
      "/public/school",
      {
        headers: { requiresAuth: false },
      },
    );

    if (data.status === ApiResponseStatus.SUCCESS && data.data) {
      dispatch(schoolActions.setSchool(data.data));
    }
  } catch (error) {
    dispatch(schoolActions.setErrorLoadingSchool(getErrorMessage(error)));
  }
};

export const updateSchool =
  (id: string, values: SchoolUpdateRequestDto) =>
  async (dispatch: AppDispatch) => {
    dispatch(schoolActions.setLoadingSchoolUpdate());
    try {
      const { data } = await axiosInstance.put<
        ApiResponseDto<SchoolResponseDto>
      >(`/school/${id}`, values, {
        headers: { requiresAuth: true },
      });
      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        toast.success(data.message || "School details updated successfully!");
        dispatch(schoolActions.updateSchoolSuccess(data.data));
        dispatch(schoolActions.setServerResponseStatus(data.statusCode || 200));
      }
    } catch (error) {
      dispatch(schoolActions.setErrorUpdatingSchool(getErrorMessage(error)));
    }
  };

export const resetSchoolServerStatus = () => (dispatch: AppDispatch) => {
  dispatch(schoolActions.setServerResponseStatus(null));
};
